import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/Order/OrderBilling.requests'

type OrderCount = {
    orderCount: number
}

export default (id: number, options: {
    validFrom?: string,
    validTo?: string,
    openConfirmDialog?: boolean
} = {
    validFrom: null,
    validTo: null,
    openConfirmDialog: true,
}) => {
    const {
        validFrom, validTo, openConfirmDialog,
    } = options

    return useRequest<OrderCount>({
        key: RequestKeys.getOrderCountForAdditionalFee,
        params: {
            id,
            data: {
                validTo, validFrom,
            },
        },
        requestFunc: RequestFn.getEntity(config.countOrdersWithAdditionalFee),
        enabled: Boolean(id) && openConfirmDialog,
    })
}
